import { AiTwotoneStar } from 'react-icons/ai'
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import HTMLString from '../../util/HTMLstring';

const BulletinItem = (props) => {
  const windowWidth = useSelector(selectWindowWidth);

  return (
    <Card key={props.idx} className='border-0 shadow' style={{ background: '#fff' }}>
      <Card.Body>
        <Card.Title style={{ fontSize: windowWidth > 900 ? '30px' : '20px', fontWeight: 'bold', fontFamily: 'Noto Sans TC' }}>
          <AiTwotoneStar color='orange' style={{ margin: '0px 8px 3px 0px' }} />
          {props.data.title}
        </Card.Title>
        <hr />
        <Card.Text style={{ fontSize: windowWidth > 900 ? '20px' : '15px', fontFamily: 'Noto Sans TC', fontWeight: '400' }}>
          <HTMLString htmlString={props.data.content}/>
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default BulletinItem;